import { render, staticRenderFns } from "./modalNewsletterAdd.vue?vue&type=template&id=8f9c5038&scoped=true&"
import script from "./modalNewsletterAdd.vue?vue&type=script&lang=js&"
export * from "./modalNewsletterAdd.vue?vue&type=script&lang=js&"
import style0 from "./modalNewsletterAdd.vue?vue&type=style&index=0&id=8f9c5038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9c5038",
  null
  
)

export default component.exports